var map = {
	"./2020.png": 20,
	"./404-adna.png": 35,
	"./CAFFEINE.png": 92,
	"./behavior.png": 93,
	"./behavior_exercise.png": 94,
	"./behavior_sleep.png": 95,
	"./behavior_snacking.png": 96,
	"./body.png": 97,
	"./body_adiposity.png": 98,
	"./body_foodcravings.png": 99,
	"./body_imc.png": 100,
	"./body_insulin.png": 101,
	"./body_ldl.png": 102,
	"./body_steatosis.png": 103,
	"./body_triglycerides.png": 104,
	"./body_weightloss.png": 105,
	"./body_weightregain.png": 106,
	"./body_whr.png": 107,
	"./cerba.png": 108,
	"./dnyou.png": 109,
	"./flag_DE.png": 36,
	"./flag_EN.png": 37,
	"./flag_ES-ES.png": 38,
	"./flag_FR-FR.png": 39,
	"./flag_IT-IT.png": 40,
	"./flag_PT-BR.png": 41,
	"./flag_PT-PT.png": 42,
	"./food.png": 110,
	"./food_caffeine.png": 111,
	"./food_carbs.png": 112,
	"./food_complexcarbs.png": 113,
	"./food_fat.png": 114,
	"./food_fiber.png": 115,
	"./food_gluten.png": 116,
	"./food_lactose.png": 117,
	"./food_mufa.png": 118,
	"./food_protein.png": 119,
	"./food_pufa.png": 120,
	"./food_restriction.png": 121,
	"./food_salt.png": 122,
	"./food_vitamins.png": 123,
	"./healthylab.png": 124,
	"./heartcolor.png": 21,
	"./hg-heart-logo.png": 125,
	"./hg.png": 34,
	"./invenimus.png": 126,
	"./iproprium.png": 127,
	"./nimgenetics.png": 128,
	"./pathotrier.png": 129,
	"./unilabs.png": 130
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14;